<template>
  <div class="onboaring-div">
    <div class="overlay">
      <div class="onbaording-parent">
        <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null">
          <tab-content class="mb-5" v-for="tour in tours" :key="tour.image">
            <tour-content :image="tour.image"
              :text="tour.text">
              <template v-slot:title>
                <p class="title mb-4 mt-8">
                  <span class="heightlighted-word">
                    {{ tour.title.replace(/ .*/, '') }}
                  </span>
                  {{ tour.title.substr(tour.title.indexOf(" ") + 1) }}
                </p>
              </template>
            </tour-content>
          </tab-content>

          <template slot="footer" slot-scope="props">
            <div v-if="props.isLastStep" class="text-center">
              <vs-button class="shadow-none rounded" @click="submitTour(props.isLastStep)" color="primary" type="filled">
                Let’s Start
              </vs-button>
            </div>

            <div v-else class="flex justify-between">
              <div class="skip" @click="submitTour(true)">Skip</div>

              <div>
                <wizard-button @click.native="props.prevTab()" class="p-0">
                  <img :src="prevBtn"/>
                </wizard-button>

                <wizard-button @click.native="props.nextTab(); submitTour(props.isLastStep)">
                    <img :src="nextBtn"/>
                </wizard-button>
              </div>
            </div>
          </template>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import TourContent from './components/TourContent.vue'

export default {
  data () {
    return {
      prevBtn: require('@/assets/images/tour/prev.svg'),
      nextBtn: require('@/assets/images/tour/next.svg'),
      tours: [
        {
          image: require('@/assets/images/tour/campaign.svg'),
          title: 'Enjoy a whole new Create Campaign Experience ',
          text: 'Capitalize on all the new features of the create campaign journey.  The process is faster and more user-friendly, with a smooth structure that will help you define your objective and choose your campaign type.  It also offers top-notch targeting options, including location, internet service providers, publishers, devices, and operating systems.'
        },
        {
          image: require('@/assets/images/tour/users.svg'),
          title: 'Follow the Users\' Journey Step by Step',
          text: 'With the new advanced tracking options, you can now track everything that occurs once the user clicks on your landing page. You can track users\' journeys on your landing pages as they fill in forms, sign-up, add to card, purchase a product, or register for a service. You can easily enjoy all these new perks once you add the Speakol pixel code to your landing page, or use S2S (Postback URL) Conversion Tracking.'
        },
        {
          image: require('@/assets/images/tour/accounts.svg'),
          title: 'Invite collaborators to your account',
          text: 'If you are an agency or manage different brands, this feature is for you. You can easily create subaccounts to handle various business accounts with an unlimited number of users to manage and monitor campaigns. You can assign roles granting or limiting access. Subaccounts can run their campaigns, ads, creatives, budget, targeting options, goals and optimization strategies, analytics, and reports.'
        },
        {
          image: require('@/assets/images/tour/analysis.svg'),
          title: 'Analyze. Optimize. Implement',
          text: 'We have enhanced our insights to empower you with valuable, insightful data. Now, you can easily visualize your numbers and conversions through our interactive graphs, explore the insights per ad set or publisher, and analyze the new video-specific insights granting you the power and knowledge to create a successful performance.'
        },
        {
          image: require('@/assets/images/tour/optimize.svg'),
          title: 'Optimize your Spending for Better Results',
          text: 'We have updated our consumption logic. Now, the Speakol algorithm allocates your funds to the highest performing campaigns securing the best results based on your marketing goals to better optimize your spending. You can easily set a daily cap for your campaigns with no end date, and a budget to your campaigns with a specific ending date; the funds will be deducted from your available balance.'
        }
      ]
    }
  },
  components: {
    FormWizard,
    TabContent,
    TourContent,
    WizardButton
  },
  methods: {
    submitTour (isLatest) {
      if (isLatest) {
        this.$emit('completed')
      }
    }
  }
}
</script>

<style lang="scss">
.onboaring-div {
  .heightlighted-word {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1px;
    color: #0092d7;
  }

  .onbaording-parent {
    width: 80%;
    position: fixed;
    z-index: 99999;
    background-color: white;
    left: 50%;
    top: 48%;
    transform: translate(-50%, -50%);
    margin: 20px auto;
    padding: 20px 20px 20px 20px;
    background: #fff;
    box-shadow: 0 4px 30px rgba(138, 164, 214, 0.25);
    border-radius: 3px;
  }

  .overlay {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: 100%;
    z-index: 99999;
    position: fixed;
    right: 0;
    left: 0;
  }

  .title {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
    letter-spacing: 0.10000000149011612px;
    text-align: center;
  }

  .wizard-nav-pills,
  .wizard-progress-with-circle {
    display: none !important;
  }

  .footer {
    top: 90%;
  }

  button.wizard-btn {
    padding: 0 !important;
    width: 20px;
  }

  .vue-form-wizard .navbar .navbar-nav > li > a.wizard-btn,
  .vue-form-wizard .wizard-btn {
    min-width: 40px;
  }

  .skip {
    font-weight: 500;
    font-size: 16px;
    line-height: 40px;
    color: #bdbdbd;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    #tour-form {
      height: 100%;
    }

    #tour-form {
      width: 100%;
      height: 100%;
    }

    .onbaording-parent {
      width: 80%;
      margin-top: 15px;
    }

    .vue-form-wizard .wizard-tab-content {
      padding: 0;
    }

    .onbaording-parent {
      padding: 0 20px 0 20px;
    }
  }
}

</style>
